const moderationType = {
    "REPORT_DISMISSED": "Dismiss Reported post",
    "POST_REMOVED": "Delete Post",
    "USER_BANNED": "Block User",
    "USER_UNBANNED": "User Unblocked",
  }

 export const getActionTypeBadge = (actionType) => {
  const badgeClasses = {
    'USER_BANNED': 'bg-red-100 text-red-700',
    'USER_UNBANNED': 'bg-green-100 text-green-700',
    'POST_REMOVED': 'bg-yellow-100 text-yellow-700',
    'REPORT_DISMISSED': 'bg-blue-100 text-blue-700'
  };

  return (
    <span className={`px-2 py-1 rounded-full text-xs font-medium ${badgeClasses[actionType] || 'bg-gray-100 text-gray-700'}`}>
      {actionType ? moderationType[actionType] || actionType.replace(/_/g, ' ') : 'N/A'}
    </span>
  );
};
  
export const moderationColumns = [
  {
    key: 'date',
    header: 'Date',
    width: 150,
    cell: rowData =>
      rowData.timestamp
        ? new Date(rowData.timestamp).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
        : 'N/A',
  },
  {
    key: 'actionType',
    header: 'Moderation type',
    width: 200,
     cell: rowData => getActionTypeBadge(rowData.actionType),
  },
  {
    key: 'moderator',
    header: 'Moderator',
    width: 180,
    cell: rowData => rowData.moderatorName || 'N/A',
  },
  {
    key: 'targetUser',
    header: 'Target user',
    width: 250,
    cell: rowData => rowData.targetUserName || 'N/A',
     flexGrow:2
  },
  {
    key: 'reason',
    header: 'Reason',
    flexGrow: 2,
    cell: rowData => rowData.reason || 'N/A',
  },
];

export const reportedColumns = (onView) => [
  {
    key: 'date',
    header: 'Date',
    width: 250,
    cell: row =>  new Date(row.latestReportDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }),
  },
  {
    key: 'status',
    header: 'Status',
    width: 150,
    cell: row => (
      <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
        row.status === 0 
          ? 'bg-red-100 text-red-700' 
          : 'bg-green-100 text-green-700'
      }`}>
        <span className={`w-2 h-2 rounded-full mr-2 ${
          row.status === 0 ? 'bg-red-500' : 'bg-green-500'
        }`}></span>
        {row.status === 0 ? 'Pending Review' : 'Dismissed'}
      </span>
    ),
  },
  {
    key: 'postedBy',
    header: 'Posted by',
    width: 350,
    cell: row => row.postedByFullName || 'N/A',
    flexGrow:2
  },
 
  {
    key: 'reportsCount',
    header: 'Number of reports',
    width: 50,
    cell: row => row.numberOfReports,
  },
  {
    key: 'actions',
    header: 'Actions',
    flexGrow: 1,
    cell: row => (
      <button
        className="bg-teal-500 text-white px-3 py-1 rounded"
        onClick={() => onView(row)}
      >
        View & Act
      </button>
    ),
  },
];

export const blockedColumns = (onUnblock) => [
  {
    key: 'blockedDate',
    header: 'Blocked Date',
    width: 150,
    cell: row => new Date(row.blockedAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }),
  },
  {
    key: 'name',
    header: 'Name',
    width: 180,
    cell: row => row.fullName || row.name,
  },
  {
    key: 'email',
    header: 'Email',
    width: 250,
    cell: row => row.emailAddress || row.email,
  },
  {
    key: 'reason',
    header: 'Reason',
    flexGrow: 1,
    cell: row => row.reason,
  },
  {
    key: 'actions',
    header: 'Actions',
    width: 150,
    cell: row => (
      <button
        className="bg-teal-500 text-white px-3 py-1 rounded"
        onClick={() => onUnblock(row)}
      >
        Unblock
      </button>
    ),
  },
];
